export default __webpack_public_path__ + "static/media/screen1.6ff392a6.png";